class SimulatedController {
  constructor($location, $stateParams, APIConfig, appModel, appServices, SessionProvider, utils) {
    "ngInject";
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.APIConfig = APIConfig;
    this.appModel = appModel;
    this.appServices = appServices;
    this.SessionProvider = SessionProvider;
    this.utils = utils;
  }

  $onInit() {
    const username = this.$stateParams.username;
    const token = this.$stateParams.token;
    const uoid = this.$stateParams.uoid;

    const urlParameters = this.$location.search();

    this.appModel.setCredentials(username, null, uoid, token);
    this.appModel.setDebugMode(urlParameters.debug === 'on');
  }
}

export default SimulatedController;



// WEBPACK FOOTER //
// ./client/app/pages/simulated/simulated.controller.js